/*
 *   File : phone-input.js
 *   Author : https://evoqins.com
 *   Description : Input element
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo, useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Custom style
import "../../Style/Components/phone-input.scss";

const CustomPhoneInput = memo((props) => {
  const [phone, setPhone] = useState(props.value || "");
  const [focus, setFocus] = useState(false);

  // Effect to sync the local state with the prop value
  useEffect(() => {
    setPhone(props.value || "");
  }, [props.value]);

  const _handlePhoneChange = (phone) => {
    setPhone(phone);
    props.handleChange(phone);
  };

  // handle focus
  const _handleFocus = () => {
    setFocus(true);
  };

  // handle blur
  const _handleBlur = () => {
    setFocus(false);
  };

  return (
    <div className="position-relative">
      {props.label && (
        <p
          className={`${props.labelClass} e-primary-font-poppins  line-height-20px e-text-eerie-black cursor-text bg-transparent`}
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </p>
      )}

      <div className="position-relative">
        <PhoneInput
          country={"in"}
          placeholder={""}
          value={phone}
          countryCodeEditable={false}
          // disableCountryCode={props.value === ""}
          disableCountryCode={false} // ensures +91 is shown
          disabled={props.isDisabled}
          containerClass={`e-phone-input-wrapper ${props.className} ${
            props.error
              ? "e-border-1px-ruby"
              : focus
              ? "e-border-1px-primary-blue"
              : `${
                  props.background ? props.background : "bg-transparent"
                } e-border-1px-light-silver`
          } border-radius-8 e-phone-input-wrapper`}
          inputClass={`e-phone-input bg-transparent ps-4`}
          enableAreaCodes={false}
          enableTerritories={true}
          onEnterKeyPress={props.onEnterKeyPress}
          onFocus={_handleFocus}
          onBlur={_handleBlur}
          onChange={_handlePhoneChange}
        />
        {props.value.length < 3 && props.placeholder && (
          <p className="e-text-spanish-gray e-primary-font-poppins e-font-14 e-font-weight-400 position-absolute e-custom-placeholder line-height-16px mb-0">
            {props.placeholder}
          </p>
        )}
      </div>
      {/* Error text */}
      {props.error && (
        <div
          className={`${props.errorClass} position-absolute d-flex align-items-center margin-2px-top w-max-content z-1`}
        >
          <p className="text-danger e-primary-font-poppins e-font-12 line-height-16px mb-0">
            {props.error}
          </p>
        </div>
      )}
    </div>
  );
});

export default CustomPhoneInput;
